const DEFAULT_CACHE_TIME = 1000 * 30;
const localforage = (() => {
    let store = {};
    const setItem = (key, value) => {
        store[key] = value;
        return value;
    };
    const getItem = (key) => {
        return store[key];
    };
    const removeItem = (key) => {
        store[key] = undefined;
    };
    const keys = () => Object.keys(store);
    const clear = () => {
        store = {};
    };
    return {
        setItem,
        getItem,
        removeItem,
        keys,
        clear,
    };
})();
export const set = async (key, value, options) => {
    if (typeof options !== 'object')
        options = {};
    const cacheValue = {
        data: value,
        insertTime: Date.now(),
        duration: options.duration ? options.duration : DEFAULT_CACHE_TIME,
    };
    const val = await localforage.setItem(key, cacheValue);
    return val.data;
};
const isExpired = (data) => Date.now() > data.insertTime + data.duration;
export const get = async (key) => {
    const val = await localforage.getItem(key);
    if (val == null)
        return undefined;
    if (isExpired(val)) {
        invalidate(key);
        return undefined;
    }
    return val.data;
};
export const invalidate = async (key) => {
    return await localforage.removeItem(key);
};
export const prune = async () => {
    const names = await localforage.keys();
    for (let i = 0; i < names.length; i++) {
        const key = names[i];
        const data = await localforage.getItem(key);
        if (isExpired(data)) {
            invalidate(key);
        }
    }
};
export const nuke = async () => {
    return await localforage.clear();
};
//# sourceMappingURL=cache.js.map